import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {MatMenuTrigger} from '@angular/material/menu';
import { ActionButtonModel } from '../../models';

@Component({
  selector: 'app-add-button',
  templateUrl: './add-button.component.html',
  styleUrls: ['./add-button.component.scss']
})
export class AddButtonComponent {
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  canUserCrudProp = false;
  @Output() actionClickEvent = new EventEmitter<string>();
  private actionsProp: ActionButtonModel[];

  @Input()
  public get actions(): ActionButtonModel[] {
    return this.actionsProp;
  }

  public set actions(value: ActionButtonModel[]) {
    this.actionsProp = value;
  }

  @Input()
  public get canUserCrud(): boolean {
    return this.canUserCrudProp;
  }

  public set canUserCrud(value: boolean) {
    this.canUserCrudProp = value;
  }


  actionClick(title: string) {
    this.actionClickEvent.emit(title);
  }

  disableAddButton(): boolean {
    //Todo
    return false;
    return !this.actions.some(a => a.canAdd);
  }

}
